import firebase from "firebase/app";
import "firebase/functions";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA8ZAHFzs6jzsSkf4K2-WooQKXbnAvflJ8",
  authDomain: "feriadigitalovuanl.firebaseapp.com",
  databaseURL: "https://feriadigitalovuanl.firebaseio.com",
  projectId: "feriadigitalovuanl",
  storageBucket: "feriadigitalovuanl.appspot.com",
  messagingSenderId: "192140515719",
  appId: "1:192140515719:web:f82529cac5c4212aeb9b22",
  measurementId: "G-HMXGXCS1QT"
};

firebase.initializeApp(firebaseConfig);

export const firestore = firebase.firestore();
export const functions = firebase.functions();
export const auth = firebase.auth();
export const storage = firebase.storage();
export const timestamp = firebase.firestore.FieldValue;
export const taskEvent = firebase.storage.TaskEvent;

// if (process.env.NODE_ENV === "development") {
//   auth.useEmulator("http://localhost:9099", { disableWarnings: true });
//   firestore.useEmulator("localhost", 8080);
//   functions.useEmulator("localhost", 5001);
// }



// WEBPACK FOOTER //
// ./src/firebase.js